export default theme => ({
  root: {
    display: 'grid',
    maxWidth: '100%',
    padding: 0,
    gap: 24,
    '@media screen and (min-width: 1280px)': {
      gridTemplateColumns: '1fr 1fr'
    },
    '@media screen and (min-width: 1920px)': {
      gridTemplateColumns: '1fr 1fr 1fr'
    }
  }
});